document.querySelectorAll(".partner").forEach(partner => {
  const desktop = partner.querySelector(".partner__summary-control_type_desktop");

  desktop.addEventListener("click", () => partner.classList.toggle("partner_open"));

  const heading = partner.querySelector(".partner__heading");

  heading.addEventListener("click", () => partner.classList.toggle("partner_open"));
})
